import http from "./http-common";
import axios from "axios";
const setCustomerId = () => {
  const docplaceData = localStorage.getItem("docplace");
  if (docplaceData) {
    return JSON.parse(docplaceData).customerId || "";
  }
  return "";
};
export const uploadFileManual = (
  file,
  onUploadProgress,
  doctypeId,
  archiveId,
  ignoreDynamicLocation,
  actionType
) => {
  let formData = new FormData();
  let url =
    process.env.REACT_APP_HOST_API +
   // "/automation/api/v1/Documents/UploadAsyncV2/";
"/docs/Api/V1/Documents/Upload"
  if (actionType) {
    url += `?actionType=${actionType}`;
  }

  formData.append("file", file);
  if (archiveId != null) {
    formData.append("archiveId", archiveId);
  }
  formData.append("originId", "Web Ui");
  formData.append("originType", "Web Ui");
  if (doctypeId != null) {
    formData.append("docTypeId", doctypeId);
  }
  formData.append("ignoreDynamicLocation", ignoreDynamicLocation);
  formData.append("client-id", setCustomerId());
  return http.post(url, formData, {
    headers: {
      // Do NOT set Content-Type for multipart/form-data - axios sets it automatically with correct boundary
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
      customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
      userId: JSON.parse(localStorage.getItem("docplace")).userId,
      "x-client-id": JSON.parse(localStorage.getItem("docplace")).customerId,
    },
    onUploadProgress,
  });
};
export const uploadFileAI = (
  file,
  onUploadProgress,
  doctypeId,
  archiveId,
  ignoreDynamicLocation,
  actionType
) => {
  let formData = new FormData();
  let url =
    process.env.REACT_APP_HOST_API +
    "/docs/Api/V1/Documents/Upload";

  if (actionType) {
    url += `?actionType=${actionType}`;
  }

  formData.append("file", file);
  if (archiveId != null) {
    formData.append("archiveId", archiveId);
  }
  formData.append("originId", "Web Ui");
  formData.append("originType", "Web Ui");
  if (doctypeId != null) {
    formData.append("docTypeId", doctypeId);
  }
  formData.append("ignoreDynamicLocation", ignoreDynamicLocation);
  formData.append("client-id", setCustomerId()); 

  return http.post(url, formData, {
    headers: {
      // Do NOT set Content-Type for multipart/form-data - axios sets it automatically with correct boundary
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
      customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
      userId: JSON.parse(localStorage.getItem("docplace")).userId,
      "x-client-id": JSON.parse(localStorage.getItem("docplace")).customerId,
    },
    onUploadProgress,
  });
};

export const uploadFileForTemplate = (file, onUploadProgress) => {
  let formData = new FormData();
  let url = process.env.REACT_APP_HOST_API + "/docs/Api/V1/Documents/Upload";

  formData.append("file", file);
  formData.append("originId", "Web Ui");
  formData.append("originType", "Web Ui");
  formData.append("client-id", setCustomerId());

  return http.post(url, formData, {
    headers: {
      // Do NOT set Content-Type for multipart/form-data - axios sets it automatically with correct boundary
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
      customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
      userId: JSON.parse(localStorage.getItem("docplace")).userId,
      "x-client-id": JSON.parse(localStorage.getItem("docplace")).customerId,
    },
    onUploadProgress,
  });
};

// export const uploadAttachment = (file, documentId) => {
//   let url = `${process.env.REACT_APP_HOST_API}/automation/api/v1.0/DocumentsAttach/AttachFileDocument?documentId=${documentId}`;
//
//   return http.post(url, file, {
//     headers: {
//       "Content-Type": file.type,
//       Authorization:
//         "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
//       customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
//     },
//   });
// };

export const uploadAttachment = (files, documentId) => {
  let url = `${process.env.REACT_APP_HOST_API}/automation/api/v1.0/DocumentsAttach/AttachFileDocument?documentId=${documentId}`;

  const formData = new FormData();

  files.forEach((file) => {
    formData.append(`files`, file);
  });

  return axios.post(url, formData, {
    headers: {
      // Do NOT set Content-Type for multipart/form-data - axios sets it automatically with correct boundary
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
      customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
    },
  });
};

export const validateFiles = (archiveId, fileName) => {
  let url = `${process.env.REACT_APP_HOST_API}/automation/api/v1.0/Documents/ValidateUniqueFileName`;
  const queryParams = new URLSearchParams();
  if (archiveId != null) queryParams.append("archiveId", archiveId);
  if (fileName != null) queryParams.append("fileName", fileName);

  url += `?${queryParams.toString()}`;

  return http.post(
    url,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
        customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
      },
    }
  );
};

export const uploadAndAppendDocument = (
  file,
  onUploadProgress,
  doctypeId,
  archiveId,
  id
) => {
  let formData = new FormData();
  let url =
    process.env.REACT_APP_HOST_API +
    "/automation/api/v1/Documents/MergePdfToExistingDoc/" +
    id;

  formData.append("file", file);
  if (archiveId != null) {
    formData.append("archiveId", archiveId);
  }
  formData.append("originId", "Web Ui");
  formData.append("originType", "Web Ui");
  if (doctypeId != null) {
    formData.append("doctypeId", doctypeId);
  }
  formData.append("Name", "test");
  formData.append("FileName", "test");
  // formData.append("ignoreDynamicLocation", ignoreDynamicLocation);

  return http.post(url, formData, {
    headers: {
      // Do NOT set Content-Type for multipart/form-data - axios sets it automatically with correct boundary
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
      customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
      userId: JSON.parse(localStorage.getItem("docplace")).userId,
    },
    onUploadProgress,
  });
};

export const uploadTemplate = (
  file,
  onUploadProgress,
  doctypeId,
  archiveId,
  ignoreDynamicLocation
) => {
  let formData = new FormData();
  let url =
    process.env.REACT_APP_HOST_API + "/automation/api/v1/Forms/UploadTemplate";

  formData.append("file", file);
  if (archiveId != null) {
    formData.append("archiveId", archiveId);
  }
  formData.append("originId", "Web Ui");
  formData.append("originType", "Web Ui");
  if (doctypeId != null) {
    formData.append("doctypeId", doctypeId);
  }
  formData.append("Name", "test");
  formData.append("FileName", "test");
  // formData.append("ignoreDynamicLocation", ignoreDynamicLocation);

  return http.post(url, formData, {
    headers: {
      // Do NOT set Content-Type for multipart/form-data - axios sets it automatically with correct boundary
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
      customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
    },
    onUploadProgress,
  });
};

export const uploadTemplateV2  = (
  file,
  onUploadProgress,
  doctypeId,
  archiveId,
  ignoreDynamicLocation
) => {
  let formData = new FormData();
  let url =
    process.env.REACT_APP_HOST_API + "/forms/api/v1/upload-template";

  formData.append("file", file);
  if (archiveId != null) {
    formData.append("archiveId", archiveId);
  }
  formData.append("originId", "Web Ui");
  formData.append("originType", "Web Ui");
  if (doctypeId != null) {
    formData.append("doctypeId", doctypeId);
  }
  formData.append("Name", "test");
  formData.append("FileName", "test");
  // formData.append("ignoreDynamicLocation", ignoreDynamicLocation);

  return http.post(url, formData, {
    headers: {
      // Do NOT set Content-Type for multipart/form-data - axios sets it automatically with correct boundary
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
      customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
    },
    onUploadProgress,
  });
};
export const uploadFile = (file, onUploadProgress, doctypeId) => {
  let formData = new FormData();
  let url =
    process.env.REACT_APP_HOST_API + "/automation/api/v1/Doctype/UploadV2";

  formData.append("file", file);

  return http.post(url, formData, {
    headers: {
      // Do NOT set Content-Type for multipart/form-data - axios sets it automatically with correct boundary
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
      customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
      doctypeId: doctypeId,
    },
    onUploadProgress,
  });
};

export const uploadTemplateByDocumentId = (documentId, { useAi = true, templateName } = {}) => {
  let url =
    process.env.REACT_APP_HOST_API + "/forms/api/v1/template-document";
  const body = {
    "document_id": documentId,
    "use_ai": Boolean(useAi)
  }
  if (templateName && String(templateName).trim()) {
    body.template_name = String(templateName).trim();
  }

  return http.post(url, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
      customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
    },
  });
}

export const getUploadedFiles = (onUploadProgress, doctypeId) => {
  let url =
    process.env.REACT_APP_HOST_API +
    "/automation/api/v1/Doctype/GetSamp" +
    "leFiles";

  return http.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
      customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
      doctypeId: doctypeId,
    },
    onUploadProgress,
  });
};

/**UPLOAD signature image PNG */
export const uploadSignature = (file, name, email, onUploadProgress) => {
  let formData = new FormData();
  let url =
    process.env.REACT_APP_HOST_API +
    "/automation/api/v1.0/Signature/User/" +
    JSON.parse(localStorage.getItem("docplace")).userId;
  formData.append("file", file, "image.png"); //upload the blob image
  formData.append("type", "INTERNAL");
  formData.append("acceptTermsAndConditions", "1");
  formData.append("name", name);
  formData.append("email", email);

  return http.post(url, formData, {
    headers: {
      // Do NOT set Content-Type for multipart/form-data - axios sets it automatically with correct boundary
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
      customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
      doctypeId: "",
      userId: JSON.parse(localStorage.getItem("docplace")).userId,
    },
    onUploadProgress,
  });
};
